/**
 * iCloud 登录接口（iosLoginVerification）返回码的统一口径。
 *
 * 这套码原本硬编码在 12 个弹窗里（10003 / 10004 / 10005 …），改规则要翻十几个文件。
 * 这里集中定义一次；组件只 import 常量 + resolveIcloudLogin，不再出现魔法数字。
 *
 * ⚠️ 仅适用于 iOS / iCloud 登录流程。Android 走 android-auth，不会返回这些码。
 */

/** 成功码：0 与 10000 都算成功 */
export const ICLOUD_OK = [0, 10000]

export const ICLOUD_EC = {
  PASSWORD: 10003, // 密码不对（可能已在 iPhone 上改过密码）
  TWO_STEP: 10004, // 需要二步验证：切到填验证码那一步
  LOCKED: 10005, // Apple ID 被锁
  TERMS: 10031 // 需要先同意条款
}

/** 是否成功。传整个 data 或直接传 ec 都行 */
export const isIcloudOk = input => {
  const ec = input && typeof input === 'object' ? input.ec : input

  return ICLOUD_OK.includes(ec)
}

/** 发验证码场景的「算成功」：成功码，或需要二步验证（说明码已发出） */
export const isIcloudSendOk = ec => isIcloudOk(ec) || ec === ICLOUD_EC.TWO_STEP

/**
 * 一次 iCloud 登录返回该怎么处理。纯函数，不依赖 React，可直接单测。
 *
 * @param {object} data 接口返回体（读 data.ec / data.em）
 * @param {object} [ctx]
 * @param {number}  [ctx.step=0]           组件当前步骤：0 = 输入账号密码，1 = 填验证码
 * @param {boolean} [ctx.lockedFlowOpen]   被锁 / 重新验证弹窗是否正在显示
 * @returns {{ type: 'ok'|'twoStep'|'locked'|'terms'|'reenterPassword'|'toast', ec: number, message: string }}
 */
export const resolveIcloudLogin = (data, { step = 0, lockedFlowOpen = false } = {}) => {
  const ec = data?.ec
  const message = data?.em || ''

  if (isIcloudOk(ec)) return { type: 'ok', ec, message }
  if (ec === ICLOUD_EC.TWO_STEP) return { type: 'twoStep', ec, message }
  if (ec === ICLOUD_EC.LOCKED) return { type: 'locked', ec, message }
  if (ec === ICLOUD_EC.TERMS) return { type: 'terms', ec, message }

  // 密码不对 → 退回「输入账号密码」重填。
  // 例外：已经停在输密码那一步、或被锁 / 重新验证弹窗正开着 → 只提示，不退回
  if (ec === ICLOUD_EC.PASSWORD && step !== 0 && !lockedFlowOpen) {
    return { type: 'reenterPassword', ec, message }
  }

  return { type: 'toast', ec, message }
}
